import { Trial_Status } from "@generated/graphql";
import { AuthSettingName } from "constants/candidate.constants";
import { GRADE_OPTIONS } from "constants/global";
import dayjs from "dayjs";
import { getTelegramUserName } from "helpers/form.helpers";
import { getPersonalExaminationLink } from "helpers/index";
import { getTestingBaseFormData } from "pages/Testing/utils/form.utils";
import { CompetencyMapOptionList, ScenarioOption } from "pages/Testing/view/types";
import { InfoInputs, Trial } from "../types";

const useInitTrialForm = (
  trial: Trial,
  competencyMap: NonNullable<CompetencyMapOptionList>[number] | undefined | null,
  scenario: ScenarioOption | undefined | null
): InfoInputs => {
  const companyCandidate = trial?.companyCandidate;
  const candidateUsername = companyCandidate?.candidateUsername;
  const comment = trial?.comment;
  const trialStatusHistory = trial?.trialStatusHistory;
  const completedAt = trial?.completedAt;

  const startedAt = trialStatusHistory?.find((history) => history.newStatus === Trial_Status.Started)?.createdAt;

  let assessmentLink;
  if (trial?.id) {
    assessmentLink = getPersonalExaminationLink(trial.id, candidateUsername?.telegramUsername);
  }

  return {
    ...getTestingBaseFormData(trial?.id, trial?.examination, competencyMap, scenario),
    link: assessmentLink,
    candidate: {
      id: companyCandidate?.id || "",
      numericId: companyCandidate?.numericId.toString() || "",
      fullName: companyCandidate?.fullName || "",
      grade: GRADE_OPTIONS?.find((grade) => companyCandidate?.grade === grade.id) || null,
      telegramUsername: getTelegramUserName(candidateUsername),
      phoneNumber: candidateUsername?.candidate?.phoneNumber?.replace("+", "") || "",
      email: companyCandidate?.candidateUsername?.email || "",
      workEmail: companyCandidate?.email || "",
      organization: companyCandidate?.organization,
      position: companyCandidate?.position,
      login: companyCandidate?.candidateUsername?.login || "",
      yandexEmail: companyCandidate?.candidateUsername?.yandexEmail,
      vkId: companyCandidate?.candidateUsername?.vkId,
    },
    authSettingsSwitch: {
      [AuthSettingName.EMAIL]: !!companyCandidate?.candidateUsername?.email,
      [AuthSettingName.YANDEX_ID]: !!companyCandidate?.candidateUsername?.yandexEmail,
      [AuthSettingName.LOGIN]: !!companyCandidate?.candidateUsername?.login,
      [AuthSettingName.VK_ID]: !!companyCandidate?.candidateUsername?.vkId,
      [AuthSettingName.TELEGRAM]: !!companyCandidate?.candidateUsername?.telegramUsername,
    },
    comment,
    completedAt: completedAt ? dayjs(completedAt).format("DD.MM.YYYY HH:mm") : "",
    startedAt: startedAt ? dayjs(startedAt).format("DD.MM.YYYY HH:mm") : "",
  };
};

export default useInitTrialForm;
